import { AddAccountApiParameterExt, addAccountExt as addAccountApiExt } from "@GeriMed/Services/AccountServiceExt";
import { becomeACustomer, BecomeACustomerParameterExt } from "@GeriMed/Services/BecomeACustomer";
import {  BecomeACustomerModel } from "@GeriMed/Type/ApiModelsExt";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";

export interface BecomeAcustomerParameter {
    Properties: any;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    BecomeAcustomerParameter,
    BecomeACustomerParameterExt,
    ServiceResult<BecomeACustomerModel>
>;

export const PopulateApiParameterExt: HandlerType = props => {
    props.apiParameter = {
        account: {
             ...props.parameter.Properties,
        } as unknown as BecomeACustomerModel,
    };
};

export const BecomeAcustomer: HandlerType = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await becomeACustomer(props.apiParameter);
    watchForOtherTabSessionChange();
};

export const chain = [
    PopulateApiParameterExt,
    BecomeAcustomer,
];

const becomeAcustomer = createHandlerChainRunner(chain, "BecomeAcustomer");
export default becomeAcustomer;
